// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function button1_viewportEnter(event, $w) {
	//Add your code for this event here: 
}